export default function BoardContent({children}){
    return(
        <div className="board-content">
            {children}
        </div>
    )
}